import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';
import {
  CreateGroupParams,
  GetFilteredGroupsParams,
  GetFilteredGroupsResponse,
  GetGroupMembersParams,
  GetGroupMembersResponse,
  Group,
  UpdateGroupMembersParams,
  UpdateGroupMembersResponse,
  UpdateGroupParams,
  UpdateGroupsParams,
  UpdateGroupsResponse,
} from '../groups.proto';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private readonly apiService: ApiService) {}

  getFilteredGroups(
    getFilteredGroupsParams: GetFilteredGroupsParams
  ): Observable<GetFilteredGroupsResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getFilteredGroupsParams
    );
    return this.apiService.get(`/v2/groups`, params);
  }

  getGroupMembers(
    getGroupMembersParams: GetGroupMembersParams
  ): Observable<GetGroupMembersResponse> {
    const params: HttpParams = this.apiService.queryParams(getGroupMembersParams);
    return this.apiService.get(
      `/v2/groups/${getGroupMembersParams.groupId}/members`,
      params
    );
  }

  createGroup(createGroupParams: CreateGroupParams): Observable<Group> {
    return this.apiService.post('/v2/groups', createGroupParams);
  }

  updateGroup(updateGroupParams: UpdateGroupParams): Observable<Group> {
    return this.apiService.put(
      `/v2/groups/${updateGroupParams.groupId}`,
      updateGroupParams
    );
  }

  updateGroups(
    updateGroupsParams: UpdateGroupsParams
  ): Observable<UpdateGroupsResponse> {
    return this.apiService.put(`/v2/groups`, updateGroupsParams);
  }

  updateGroupLines(
    updateGroupMembersParams: UpdateGroupMembersParams
  ): Observable<UpdateGroupMembersResponse> {
    return this.apiService.put(
      `/v2/groups/${updateGroupMembersParams.groupId}/members`,
      updateGroupMembersParams
    );
  }
}
